/* eslint-disable perfectionist/sort-jsx-props */
/* eslint-disable react/prop-types */
import clsx from "clsx";
import React, { FunctionComponent } from "react";

type Props = {
  className?: string;
};

export const MiniLogo: FunctionComponent<Props> = ({ className }) => (
  <svg
    className={clsx("block", className)}
    fill="none"
    viewBox="0 0 500 219.323"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M314.36 85.063v49.122h11.027V85.063zM259.667 85.063v49.122h10.246v-32.032l22.019 32.032h11.065V85.063h-10.245v32.803l-22.354-32.803zM238.06 85.063v49.122h11.027V85.063zM174.613 85.063v49.122h10.244V95.518l10.806 38.667h10.617l10.842-38.667v38.667h10.246V85.063h-16.543l-9.798 33.507-9.91-33.507z"
      fill="#120a08"
    />
    <path
      d="M250 0a109.624 109.624 0 0 0-92.393 50.652H0l15.69 15.69h133.73a109.624 109.624 0 0 0-6.02 18.281H33.97l15.5 15.498h91.394a109.624 109.624 0 0 0-.486 9.504 109.624 109.624 0 0 0 .437 8.777H67.75L83.248 133.9h59.951a109.624 109.624 0 0 0 5.781 18.28h-47.453l15.69 15.691h40.068A109.624 109.624 0 0 0 250 219.248a109.624 109.624 0 0 0 92.715-51.377h40.066l15.692-15.691h-47.454a109.624 109.624 0 0 0 5.782-18.28h59.951l15.498-15.498h-73.065a109.624 109.624 0 0 0 .438-8.777 109.624 109.624 0 0 0-.484-9.504h91.392l15.5-15.498H356.6a109.624 109.624 0 0 0-6.02-18.281h133.73L500 50.652H342.393A109.624 109.624 0 0 0 250 0zm0 14.86a94.765 94.765 0 0 1 94.764 94.765A94.765 94.765 0 0 1 250 204.391a94.765 94.765 0 0 1-94.766-94.766A94.765 94.765 0 0 1 250 14.859z"
      fill="#120a08"
    />
  </svg>
);
